import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SECONDARY_ANALYSES_SET_ACTIVE } from 'redux/actionTypes/secondaryAnalyses';
var setActiveSecondaryAnalysis = function setActiveSecondaryAnalysis(secondaryAnalysisId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var activeSecondaryAnalysisId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              activeSecondaryAnalysisId = getState().secondaryAnalyses.meta.activeSecondaryAnalysisId;
              if (!(activeSecondaryAnalysisId === secondaryAnalysisId)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", null);
            case 3:
              dispatch({
                type: SECONDARY_ANALYSES_SET_ACTIVE,
                payload: {
                  secondaryAnalysisId: secondaryAnalysisId
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default setActiveSecondaryAnalysis;